module.exports = __webpack_public_path__ + "img/istay-orange-text.bd048e3f.png";